import { render, staticRenderFns } from "./RepairResourceList.vue?vue&type=template&id=f2892be4&"
import script from "./RepairResourceList.vue?vue&type=script&lang=js&"
export * from "./RepairResourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports